<nx-context-menu #localeMenu="nxContextMenu">
  <nx-context-menu-header>{{ 'locale-selector.title' | translate }}</nx-context-menu-header>
  @for (language of availableLanguages; track language) {
    <button
      nxContextMenuItem
      selectable
      type="button"
      (click)="onSelectLanguage(language.value)"
      role="menuitemradio"
      aria-checked="true"
    >
      @if (selectedLanguage === language.value) {
        <nx-icon aria-hidden="true" name="check" nxIconPositionStart />
      }
      {{ language.label }}
    </button>
  }
</nx-context-menu>

<button
  nxButton="primary small"
  [nxContextMenuTriggerFor]="localeMenu"
  [attr.aria-label]="'locale-selector.accessibility-label' | translate"
  type="button"
  data-testid="locale-selector"
>
  <nx-icon aria-hidden="true" size="s" name="globe" class="nx-margin-right-xs" />
  <span class="uppercase">{{ selectedLanguage?.substring(0, 2) }}</span>
</button>
